@if (!hidden && (hideGamingCrossSellByArc$ | async) === false) {
    <div class="header">
        <div class="title">{{ model.title }}</div>
        <div class="link">
            <a class="link" [attr.target]="model.link?.target" (click)="openAll()">
                <span>{{ model.link?.link }}</span>
                <vn-icon name="theme-right" class="banner-theme-right" size="13" />
            </a>
        </div>
    </div>
    <div class="body">
        <div class="scrolling-wrapper">
            <ms-scroll-adapter [scrollItems]="games">
                @for (game of games; track game.id; let index = $index) {
                    <div class="img-wrapper">
                        <a class="link" (click)="openGame(game, index)">
                            <img width="80" height="80" [ngSrc]="game.imageUrl" />
                        </a>
                    </div>
                }
            </ms-scroll-adapter>
        </div>
    </div>
}
